import { ParagraphListItemSkeleton } from '@/Domain/components/KnowledgeBase/ParagraphsSheet/ParagraphList/Skeleton/ParagraphListItem.skeleton';

export const ParagraphListSkeleton = () => (
  <div className="flex-1">
    <section className="grid grid-cols-[0.1fr_1fr_0.1fr] py-3 px-4 text-foreground-subtle bg-muted text-sm font-medium">
      <span>No</span>
      <span className="pl-1">Paragraph</span>
      <span />
    </section>

    {Array.from({ length: 8 }).map((_, index) => (
      <ParagraphListItemSkeleton key={index} index={index} />
    ))}
  </div>
);
